import { combineReducers } from 'redux'
import error from './error'
import forms from './forms'
import schema from './schema'
import viewSelected from './viewSelected'
import sortMenuOpen from './sortMenuOpen'
import panelExpanded from './panelExpanded'
import sort from './sort'
import addOrEdit from './addOrEdit'
import validationError from './validationError'

export default combineReducers({
  addOrEdit,
  error,
  forms,
  schema,
  viewSelected,
  sortMenuOpen,
  panelExpanded,
  sort,
  validationError,
})
